module.exports = __webpack_public_path__ + "img/paypal.435bb47d.png";